import { scrollToId, WHATSAPP_URL } from "@/lib/scroll";

const LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "work", label: "Our Work" },
  { id: "packages", label: "Packages" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-ivory border-t border-taupe-line">
    <div className="container-x pt-20 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <button data-testid="footer-logo" onClick={() => scrollToId("home")} className="font-serif text-3xl sm:text-4xl tracking-[0.32em] text-charcoal hover:text-sage transition-colors text-left">
            AMARA <span className="text-taupe">STUDIOS</span>
          </button>
          <p className="font-serif italic text-xl sm:text-2xl text-ink/70 font-light mt-6 max-w-md leading-snug">Websites designed to be seen. Experiences designed to be remembered.</p>
        </div>
        <nav className="lg:col-span-3 lg:col-start-8" aria-label="Footer">
          <p className="eyebrow mb-5">Explore</p>
          <ul className="grid grid-cols-2 gap-y-3 gap-x-6">
            {LINKS.map((l) => (
              <li key={l.id}><button data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)} className="link-underline text-sm text-ink/80 hover:text-charcoal">{l.label}</button></li>
            ))}
            <li><a data-testid="footer-link-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="link-underline text-sm text-ink/80 hover:text-charcoal">WhatsApp</a></li>
          </ul>
        </nav>
        <div className="lg:col-span-2">
          <p className="eyebrow mb-5">Studio</p>
          <p data-testid="footer-location" className="text-sm text-ink/80">Bangalore, India</p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="link-underline text-sm text-ink/80 hover:text-charcoal mt-3 inline-block">+91 91482 36699</a>
        </div>
      </div>
      <div className="mt-16 pt-6 border-t border-taupe-line flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-taupe">
        <span>© {new Date().getFullYear()} Amara Studios</span>
        <span>A M A R A &nbsp; S T U D I O S</span>
      </div>
    </div>
  </footer>
);
